import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Location, UserType, User } from '../../models/user.model';
import { environment } from '../../../environments/environment';
import { ReportMetadata, ReportCategory, ReportYear,ReportState, FrequencyType, ReportAutoPublishPolicy, ReportType, ReportDistributionType, CountryReport, ReportCategoryRank} from '../../models/report.model';
import { map } from 'rxjs/operators';
@Injectable()
export class LookupService {

  // endpoint = 'http://localhost:58830/api/Lookup/';

  endpoint = environment.apiEndpoint + '/Lookup/';

  constructor(private http: HttpClient) { }

  getUserTypes(): Observable<any> {
    return this.http.get(this.endpoint + 'GetUserTypes');
  }

  getAppRoles(): Observable<any> {
    return this.http.get(this.endpoint + 'GetAppRoles');
  }

  getAppRolesByUserTypeId(userTypeId: number): Observable<any> {
    return this.http.get(this.endpoint + 'GetAppRolesByUserTypeId?userTypeId=' + userTypeId);
  }

  getRootLocations(userType: string): Observable<any> {
    return this.http.get(this.endpoint + 'GetRootLocations?userType=' + userType);
    //  return this.http.post(this.endpoint + 'GetRootLocations', userType);
  }

  getChildLocations(parentId: Number): Observable<any> {
     return this.http.get(this.endpoint + 'GetChildLocations?parentLocationId=' + parentId);
  }

  getLocation(locationId: Number): Observable<any> {
    return this.http.get(this.endpoint + 'GetLocation?locationId=' + locationId);
  }

  getParentLocation(locationId: Number): Observable<any> {
    return this.http.get(this.endpoint + 'GetParentLocation?locationId=' + locationId);
 }

  getLocationHierarchy(locationId: number): Observable<any> {
    return this.http.get(this.endpoint + 'GetLocationHierarchy?locationId=' + locationId);
  }

 getReportCategoryById(id: number): Observable<any> {
    return this.http.get(this.endpoint + 'GetReportCategory?id=' + id);
  }

  getUserLocations(): Observable<any> {
    //return this.http.get('http://localhost:58830/api/User/GetUserLocations');
    return this.http.get(environment.apiEndpoint + '/User/GetUserLocations');
  }

  getUserCategories(): Observable<any> {
    //return this.http.get('http://localhost:58830/api/User/GetUserLocations');
    return this.http.get(environment.apiEndpoint + '/User/GetUserCategories');
  }

  getUserAllReportCategories(): Observable<any> {
    //return this.http.get('http://localhost:58830/api/User/GetUserLocations');
    return this.http.get(environment.apiEndpoint + '/User/GetUserReportCategories');
  }

  getPostApprovers(postId: number): Observable<any> {
    return this.http.get(this.endpoint + 'GetPostApprovers?postLocationId=' + postId);
  }

  GetReportCategories(locationId: number):Observable<any>{
    //console.log("From Service "+ locationId);
    return this.http.get(this.endpoint + 'GetReportCategories?programAreaId=' + locationId)
  }
  getAllReportCategories$ ():Observable<ReportCategory[]>{
    return this.http.get(this.endpoint+'GetReportCategories').pipe(map((reportCategories:ReportCategory[])=>reportCategories));
  }


  getReportYear():Observable<any>{
    return this.http.get(this.endpoint + 'GetReportYears');
  }

  getAllActiveUsers$():Observable<User[]>{
    return this.http.get(environment.apiEndpoint + '/User/GetAllActiveUsers').pipe(map((usersList:User[])=>usersList));
  }

  getPendingHqUsers$(): Observable<User[]>{
    return this.http.get<User[]>(environment.apiEndpoint + '/User/GetPendingHqUsers');
  }

  getAllDeActiveUsers$(): Observable<User[]>{
    return this.http.get<User[]>(environment.apiEndpoint + '/User/GetAllDeActiveUsers').pipe(map((usersList:User[])=>usersList));;
  }

  getAllRegions$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllRegions').pipe(map((regionList:Location[])=>regionList));
  }
  getAllCountries$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllCountries').pipe(map((countryList:Location[])=>countryList));
  }
  getAllPosts$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllPosts').pipe(map((postList:Location[])=>postList));
  }

  getAllProgramAreas$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllProgramAreas').pipe(map((programAreaList:Location[])=>programAreaList));
  }

  getAllDivisions$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllDivisions').pipe(map((divisionList:Location[])=>divisionList));
  }

  getAllActiveProgramAreas$():Observable<Location[]>{
    return this.http.get(this.endpoint + 'GetAllActiveProgramAreas').pipe(map((programAreaList:Location[])=>programAreaList));
  }
  getAllActiveReportAutoPublishPolicies$():Observable<ReportAutoPublishPolicy[]>{
    return this.http.get(this.endpoint + 'GetAllActiveReportAutoPublishPolicies').pipe(map((autoPublishPolicyList:ReportAutoPublishPolicy[])=>autoPublishPolicyList));
  }
  getAllActiveReportCategories$():Observable<ReportCategory[]>{
    return this.http.get(this.endpoint + 'GetAllActiveReportCategories').pipe(map((reportCategories:ReportCategory[])=>reportCategories));
  }

  getReportCategoryHierarchy$(includeAll:boolean=true):Observable<any>{
    return this.http.get(this.endpoint + 'GetReportCategoryHierarchy?includeAll='+includeAll);
  }

  getReportStates$():Observable<ReportState[]>{
    return this.http.get(this.endpoint+'GetReportStates').pipe(map((reportStatesList:ReportState[])=>reportStatesList));
  }
  getFrequencyTypes$():Observable<FrequencyType[]>{
    return this.http.get(this.endpoint+'GetFrequencyTypes').pipe(map((frequencyTypes:FrequencyType[])=>frequencyTypes));
  }

  getAllReportTypes$():Observable<ReportType[]>{
    return this.http.get(this.endpoint+'GetAllReportTypes').pipe(map((reportTypesList:ReportType[])=>reportTypesList));
  }

  getAllReportDistributionTypes$():Observable<ReportDistributionType[]>{
    return this.http.get(this.endpoint+'GetAllReportDistributionTypes').pipe(map((reportDistributionTypesList:ReportDistributionType[])=>reportDistributionTypesList));
  }

  GetPercentageReportByCountry(countryId: number, appUserId: number):Observable<CountryReport>{
    return this.http.get(this.endpoint+'GetPercentageReportByCountry?countryId=' + countryId + '&appUserId=' + appUserId).pipe(map((result:CountryReport)=>result));
  }

  GetTopFiveReportCategories(countryId: number, appUserId: number):Observable<ReportCategoryRank[]>{
    return this.http.get(this.endpoint+'GetTopFiveReportCategories?countryId=' + countryId + '&appUserId=' + appUserId).pipe(map((result:ReportCategoryRank[])=>result));
  }
}
